// React
import { useMemo } from 'react'

// React Router Dom
import { useLocation } from 'react-router-dom'

const useQuery = () => {
  const { search } = useLocation()

  return useMemo(() => new URLSearchParams(search), [search])
}

export { useQuery }
